import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, TransitionGroup as _TransitionGroup, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b2ebc2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-0 flex gap-2 h-15 items-center justify-between font-light" }
const _hoisted_2 = { class: "flex gap-6 pl-10" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "transition duration-100" }
const _hoisted_5 = { class: "px-10 justify-between text-13 bg-gray-theme-300 flex-shrink-0 flex items-center h-10 text-xs sticky top-0 z-1 text-gray-theme-500 border-solid border-0 border-b shadow-sm" }
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = { class: "rounded-md inline-flex button-bg rounded-md px-1 py-0.5" }
const _hoisted_8 = { class: "flex gap-3 items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "capitalize" }, "Open command palette for bulk actions", -1))
const _hoisted_10 = { class: "rounded-md button-bg rounded-md px-1 py-0.5" }
const _hoisted_11 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex gap-3 items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "capitalize" }, "Load 30 conversations more")
], -1))
const _hoisted_13 = { class: "flex gap-3 items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "capitalize" }, "Refresh", -1))
const _hoisted_15 = { class: "rounded-md button-bg rounded-md px-1 py-0.5" }
const _hoisted_16 = {
  key: 0,
  class: "absolute top-12 left-0 bottom-0 right-0 flex flex-col gap-4 pt-4 items-center justify-center bg-white"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-theme-500" }, " Loading conversations...", -1))
const _hoisted_18 = {
  key: 0,
  class: "pl-3 text-sm justify-center mt-2 flex"
}

import {
	ref,
	onBeforeUnmount,
	watch,
	computed,
	onMounted
} from 'vue';
import {
	BaseConversation,
	useConversations
} from '../composition';
import ConversationItem from './components/ConversationItem.vue';
import {
	useActiveElement,
	useMagicKeys,
	useToggle,
	whenever
} from '@vueuse/core';
import { useRouter } from 'vue-router';
import UnreadMarker from './components/UnreadMarker.vue';
import { useArrowEvents } from '@/command-palette';
import {
	useUiState,
	UiLoader,
	SvgIcon,
	BorderedButton,
	Tooltip
} from '@/ui-kit';
import { useConversationsActions } from './use-conversations-action';
import { ElInfiniteScroll as vInfiniteScroll } from 'element-plus/lib';
import { detectOs } from '@/utils';
import {
	useMouseInElement,
	onClickOutside
} from '@vueuse/core';
import {
	shiftKeyChar,
	useCommandPaletteActions
} from '@/command-palette/use-command-palette-actions';


export default /*#__PURE__*/_defineComponent({
  __name: 'Conversations',
  setup(__props) {

const {
	loadConversations,
	cancelLoad,
	conversations,
	isLoaded,
	filters,
	activeFilterBy,
	selectedConversation,
	setSelectedConversation,
	unreadCount,
	hasMore,
	page,
	setSelectedConversations,
	isSelectedConversation,
	totalItems,
	isRefreshing,
	selectedConversationsSize,
	refreshConversations,
	selectedConversations
} = useConversations();

const [moreLoading, toggleMoreLoading] = useToggle();

if (!isLoaded.value) {
	loadConversations();
}

const itemsRef = ref<
	Array<InstanceType<typeof ConversationItem>>
>([]);
const router = useRouter();
const scrolling = ref(false);
const hovered = computed(
	() => ui.selectedBlockName === 'center'
);

const { space, escape, current } = useMagicKeys();
const {
	onArrowDown,
	onArrowUp,
	onArrowLeft,
	onArrowRight
} = useArrowEvents(undefined, 'externalComposeInput');
const {
	setBasicActions,
	setConversationActions,
	setBulkActions
} = useConversationsActions();
const { setIsOpened } = useCommandPaletteActions();
const ui = useUiState();

const currentOs = detectOs();
const isMacOs = currentOs === 'MacOS';
const ctrlKey = isMacOs ? '⌘' : 'Ctrl';

function selectConversation(conv: BaseConversation) {
	setSelectedConversation(conv);
	if (selectedConversationsSize.value) {
		setBulkActions();
	} else {
		setConversationActions();
	}
}

whenever(
	() => {
		return (
			escape.value &&
			ui.isNoDialogAndDropdown &&
			hovered.value &&
			selectedConversationsSize.value
		);
	},
	() => {
		setSelectedConversations([]);
	}
);

whenever(
	() =>
		current.size === 2 &&
		current.has('shift') &&
		current.has('r') &&
		!isRefreshing.value &&
		isLoaded.value &&
		!moreLoading.value,
	() => {
		refreshConversations();
	}
);

whenever(
	() =>
		space.value &&
		selectedConversation.value &&
		ui.isNoDialogAndDropdown &&
		hovered.value &&
		!isActiveElementButton.value,
	() => {
		router.push({
			name: 'ConversationDetails',
			params: {
				leadId: selectedConversation.value!.id
			}
		});
	}
);

onArrowDown((data) => {
	if (!conversations.value.length || !hovered.value) {
		return;
	}

	scrolling.value = true;

	if (
		!selectedConversation.value ||
		isActiveElementButton.value
	) {
		selectConversation(conversations.value[0]);
		return itemsRef.value[0].focusItem(false);
	}

	const currentIdx = conversations.value.findIndex(
		(conv) => conv.id === selectedConversation.value!.id
	);
	const lastIdx = conversations.value.length - 1;

	const ctrl = isMacOs ? data.metaKey : data.ctrlKey;

	if (ctrl) {
		if (currentIdx === lastIdx) {
			return;
		}

		if (data.shiftKey) {
			const convs = conversations.value.slice(
				currentIdx,
				lastIdx + 1
			);
			setSelectedConversations(convs);
		}
		selectConversation(conversations.value[lastIdx]);
		return itemsRef.value[lastIdx].focusItem(false);
	}

	if (data.shiftKey) {
		const values = [
			...selectedConversations.value.values()
		];

		if (!values.length) {
			const convs = conversations.value.slice(
				currentIdx,
				currentIdx + 2
			);
			setSelectedConversations(convs);
			selectConversation(
				conversations.value[currentIdx + 1]
			);
			return itemsRef.value[
				currentIdx + 1
			].focusItem();
		}

		const firstIdx = conversations.value.findIndex(
			(conv) => conv.id === values[0]
		);
		const lastIdx = conversations.value.findIndex(
			(conv) => conv.id === values[values.length - 1]
		);

		if (!conversations.value[lastIdx + 1]) {
			return;
		}

		const convs = conversations.value.slice(
			firstIdx,
			lastIdx + 2
		);

		setSelectedConversations(convs);
		selectConversation(
			conversations.value[lastIdx + 1]
		);
		return itemsRef.value[lastIdx + 1].focusItem();
	}

	setSelectedConversations([]);

	if (conversations.value[currentIdx + 1]) {
		selectConversation(
			conversations.value[currentIdx + 1]
		);
		return itemsRef.value[currentIdx + 1].focusItem();
	}
});

onArrowUp((data) => {
	if (
		!conversations.value.length ||
		!hovered.value ||
		isActiveElementButton.value
	) {
		return;
	}

	scrolling.value = true;
	const lastIdx = conversations.value.length - 1;

	if (!selectedConversation.value) {
		selectConversation(conversations.value[lastIdx]);
		return itemsRef.value[lastIdx].focusItem(false);
	}

	const currentIdx = conversations.value.findIndex(
		(conv) => conv.id === selectedConversation.value!.id
	);

	if (currentIdx === 0) {
		filterActionsRef.value[
			actionFocusedIdx.value
		]?.focus();
		return;
	}

	const ctrl = isMacOs ? data.metaKey : data.ctrlKey;

	if (ctrl) {
		if (currentIdx === 0) {
			return;
		}

		if (data.shiftKey) {
			const convs = conversations.value.slice(
				0,
				currentIdx + 1
			);
			setSelectedConversations(convs);
		} else {
			selectConversation(conversations.value[0]);
		}
		return itemsRef.value[0].focusItem(false);
	}

	if (data.shiftKey) {
		const values = [
			...selectedConversations.value.values()
		];

		if (!values.length) {
			const convs = conversations.value.slice(
				currentIdx - 1,
				currentIdx + 1
			);
			setSelectedConversations(convs);
			selectConversation(
				conversations.value[currentIdx - 1]
			);
			return itemsRef.value[
				currentIdx - 1
			].focusItem();
		}

		let firstIdx = conversations.value.findIndex(
			(conv) => conv.id === values[0]
		);
		let lastIdx = conversations.value.findIndex(
			(conv) => conv.id === values[values.length - 1]
		);

		if (!conversations.value[firstIdx - 1]) {
			return;
		}

		const convs = conversations.value.slice(
			firstIdx - 1,
			lastIdx + 1
		);

		setSelectedConversations(convs);
		selectConversation(
			conversations.value[firstIdx - 1]
		);
		return itemsRef.value[firstIdx - 1].focusItem();
	}

	setSelectedConversations([]);

	if (conversations.value[currentIdx - 1]) {
		selectConversation(
			conversations.value[currentIdx - 1]
		);
		return itemsRef.value[currentIdx - 1].focusItem();
	}
});

function onConvMouseOver(conv: BaseConversation) {
	if (scrolling.value) {
		return;
	}

	if (isActiveElementButton.value) {
		filterActionsRef.value[
			actionFocusedIdx.value
		]?.blur();
	}
	selectConversation(conv);
}

setBasicActions();
onBeforeUnmount(cancelLoad);

async function load() {
	if (
		!isLoaded.value ||
		moreLoading.value ||
		!hasMore.value
	) {
		return;
	}
	toggleMoreLoading(true);
	await loadConversations(
		page.value + 1,
		activeFilterBy.value
	);
	toggleMoreLoading(false);
}

function onMouseMove() {
	if (!scrolling.value) {
		return;
	}

	scrolling.value = false;
}

const containerRef = ref<HTMLDivElement>();

const { x, sourceType, isOutside, stop } =
	useMouseInElement(containerRef);

const unwatch = watch(
	x,
	() => {
		if (!sourceType.value) {
			return;
		}

		if (isOutside.value) {
			ui.setSelectedBlock('');
		} else {
			ui.setSelectedBlock('center');
			actionFocusedIdx.value = 0;
			filterActionsRef.value[0]?.focus();
		}
		stop();
		unwatch?.();
	},
	{ immediate: true }
);

onMounted(() => {
	if (hovered.value) {
		actionFocusedIdx.value = 0;
		filterActionsRef.value[0]?.focus();
	}
});

function onEnter(e: any) {
	setSelectedConversations([]);
}

const activeElement = useActiveElement();
const actionFocusedIdx = ref(0);

onClickOutside(containerRef, () => {
	if (hovered.value) {
		actionFocusedIdx.value = 0;
		activeElement.value?.blur();
		ui.setSelectedBlock('');
	}
});

onArrowLeft(() => {
	if (hovered.value) {
		if (
			actionFocusedIdx.value === 0 ||
			!isActiveElementButton.value
		) {
			actionFocusedIdx.value = 0;
			filterActionsRef.value[0]?.blur();
			return ui.setSelectedBlock('sidebar');
		}

		actionFocusedIdx.value = actionFocusedIdx.value - 1;
		filterActionsRef.value[
			actionFocusedIdx.value
		]?.focus();
	}

	if (ui.selectedBlockName === 'right') {
		actionFocusedIdx.value = 2;
		filterActionsRef.value[2]?.focus();
		return ui.setSelectedBlock('center');
	}
});

const filterActionsRef = ref<HTMLButtonElement[]>([]);

const isActiveElementButton = computed(() => {
	return filterActionsRef.value.some(
		(el) => el === activeElement.value
	);
});

onArrowRight(() => {
	if (ui.selectedBlockName === 'center') {
		if (
			actionFocusedIdx.value === 2 ||
			!isActiveElementButton.value
		) {
			actionFocusedIdx.value = 0;
			if (
				activeElement.value &&
				containerRef.value?.contains(
					activeElement.value
				)
			) {
				activeElement.value.blur();
			}
			return ui.setSelectedBlock('right');
		}

		actionFocusedIdx.value = actionFocusedIdx.value + 1;
		filterActionsRef.value[
			actionFocusedIdx.value
		]?.focus();
	}

	if (ui.selectedBlockName === 'sidebar') {
		actionFocusedIdx.value = 0;
		filterActionsRef.value[0]?.focus();
		return ui.setSelectedBlock('center');
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "containerRef",
    ref: containerRef,
    class: _normalizeClass(["flex flex-col flex-grow h-full transition", { 'shadow-2xl': _unref(hovered) }]),
    onMouseenter: _cache[2] || (_cache[2] = ($event: any) => {
			_unref(ui).setSelectedBlock('center');
			onEnter($event);
		}),
    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_unref(ui).setSelectedBlock('')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filters), (filter) => {
          return (_openBlock(), _createElementBlock("button", {
            ref_for: true,
            ref_key: "filterActionsRef",
            ref: filterActionsRef,
            class: _normalizeClass(["py-1 font-light link text-sm transition capitalize flex gap-2 border-0 border-b border-solid", {
						active: _unref(activeFilterBy) === filter
					}]),
            onClick: ($event: any) => (_unref(loadConversations)(1, filter)),
            key: filter
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(filter), 1),
            (filter === 'unread')
              ? (_openBlock(), _createBlock(UnreadMarker, {
                  key: 0,
                  class: "flex-shrink-0",
                  count: _unref(unreadCount)
                }, null, 8, ["count"]))
              : _createCommentVNode("", true)
          ], 10, _hoisted_3))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", null, [
          _createTextVNode("Conversations "),
          (_unref(selectedConversationsSize))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" | " + _toDisplayString(_unref(selectedConversationsSize)) + " selected ", 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        (_unref(selectedConversationsSize))
          ? (_openBlock(), _createBlock(_unref(Tooltip), { key: 0 }, {
              popper: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(ctrlKey)) + " K ", 1)
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(BorderedButton), {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(setIsOpened)(true))),
                  class: "!h-6 flex items-center gap-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Bulk Actions "),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(ctrlKey)) + " K ", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      (_unref(isLoaded))
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("span", null, " Showing " + _toDisplayString(_unref(conversations).length) + " from " + _toDisplayString(_unref(totalItems)), 1),
            (_unref(hasMore))
              ? (_openBlock(), _createBlock(_unref(Tooltip), {
                  key: 0,
                  class: "flex-shrink-0",
                  disabled: 
						_unref(isRefreshing) ||
						!_unref(isLoaded) ||
						_unref(moreLoading)
					
                }, {
                  popper: _withCtx(() => [
                    _hoisted_12
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_unref(BorderedButton), {
                      disabled: 
							_unref(isRefreshing) ||
							!_unref(isLoaded) ||
							_unref(moreLoading)
						,
                      class: "flex-shrink-0 !h-6 w-24 flex items-center justify-center gap-2",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (load()))
                    }, {
                      default: _withCtx(() => [
                        (!_unref(moreLoading))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" Load more ")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" Loading... "),
                              _createVNode(_unref(UiLoader), { isSmall: "" })
                            ], 64))
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            _createVNode(_unref(Tooltip), {
              disabled: 
						_unref(isRefreshing) ||
						!_unref(isLoaded) ||
						_unref(moreLoading)
					
            }, {
              popper: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(shiftKeyChar)) + " R ", 1)
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(BorderedButton), {
                  onClick: _unref(refreshConversations),
                  disabled: 
							_unref(isRefreshing) ||
							!_unref(isLoaded) ||
							_unref(moreLoading)
						,
                  class: "!h-6 flex-shrink-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SvgIcon), {
                      name: "refresh",
                      class: _normalizeClass(["h-3 w-3", {
								'rotation-animation':
									_unref(isRefreshing) ||
									!_unref(isLoaded) ||
									_unref(moreLoading)
							}])
                    }, null, 8, ["class"])
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              _: 1
            }, 8, ["disabled"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_unref(isLoaded))
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_unref(UiLoader))
        ]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createBlock(_TransitionGroup, {
      "infinite-scroll-distance": 40,
      name: "list",
      tag: "div",
      class: "overflow-y-auto h-full flex flex-col scrollbar",
      onMousemove: onMouseMove
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(conversations), (conversation) => {
          return (_openBlock(), _createBlock(ConversationItem, {
            ref_for: true,
            ref_key: "itemsRef",
            ref: itemsRef,
            isOnFocus: scrolling.value,
            isFocused: 
					(_unref(hovered) ||
						_unref(ui).activeDialogName ===
							'commandPalette') &&
					(_unref(selectedConversation)?.id ===
						conversation.id ||
						_unref(isSelectedConversation)(
							conversation.id
						)) &&
					!_unref(isActiveElementButton)
				,
            key: conversation.id,
            conversation: conversation,
            onMouseover: ($event: any) => (onConvMouseOver(conversation))
          }, null, 8, ["isOnFocus", "isFocused", "conversation", "onMouseover"]))
        }), 128)),
        (_unref(moreLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createTextVNode(" Loading more conversations "),
              _createVNode(_unref(UiLoader), { class: "ml-2" })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })), [
      [_unref(vInfiniteScroll), load]
    ])
  ], 34))
}
}

})